import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { Nullable } from '@/shared/types/app.types'
import { uniqueId } from 'lodash'

export interface StatisticalAnalysisSidebarSearchTypeModel {
    [key:string]: Nullable<StatisticalAnalysisSidebarItemCombo> | Nullable<StatisticalAnalysisSidebarItemCombo[]>
}

export interface StatisticalAnalysisSidebarSearchTypeOptions extends StatisticalAnalysisSidebarItemCombo {
    $isDisabled?: boolean
}
export interface StatisticalAnalysisSidebarSearchTypeState {
    nameComponent: string
    typeSelection: Nullable<StatisticalAnalysisSidebarItemCombo> | Nullable<StatisticalAnalysisSidebarItemCombo[]>
    options: StatisticalAnalysisSidebarSearchTypeOptions[]
}
export const initialStatisticalAnalysisSidebarSearchTypeState =
    (): StatisticalAnalysisSidebarSearchTypeState => ({
        nameComponent: uniqueId('search-type-'),
        typeSelection: null,
        options: []
    })
